import React, {Fragment, useContext, useEffect, useState} from 'react';
import {Btn} from '../../../../AbstractElements';
import {Form, FormGroup, Label} from 'reactstrap';
import axiosConfig from '../../../../Config/axios';
import {useForm} from "react-hook-form";
import TextInput from "../../../../CommonElements/Input/TextInput";
import Loader from "../../../../Layout/Loader";
import {getPrivilegeRoute} from "../../../../Route/RouteIndex";
import AuthorizationContext from "../../../../_helper/Authorization";
import type {Role, RoleFormValues} from "../Types/RoleTypes";
import type {AuthorizationContextType} from "../../../../_helper/Authorization/AuthorizationTypes";

interface RoleFormComponentProps {
    callBack?: (role: Role) => void;
    role?: Role|null;
    isUpdate?: boolean;
}

const RoleForm: React.FC<RoleFormComponentProps> = ({callBack, role}) => {
    const [loaderVisibility, setLoaderVisibility] = useState<boolean>(false);
    const authContext = useContext(AuthorizationContext) as AuthorizationContextType;
    const {errorHandler} = authContext || {};

    const {
        register,
        handleSubmit,
        setError,
        setValue,
        clearErrors,
        formState: {errors},
        watch
    } = useForm<RoleFormValues>();

    useEffect(() => {
        if (role) {
            setValue('name', role.name);
            setValue('display_name', role.display_name);
            setValue('description', role.description);
        }
    }, [role, setValue])

    const onSubmit = (data: RoleFormValues) => {
        clearErrors();
        setLoaderVisibility(true);
        role ? updateRole(data) : createRole(data);
    }

    const createRole = (data: RoleFormValues) => {
        axiosConfig
            .post(getPrivilegeRoute('role'), data)
            .then((response: { data: { data: Role; }; }) => {
                if (response?.data?.data) {
                    callBack && callBack(response?.data?.data);
                }
                setLoaderVisibility(false);
            })
            .catch((exception: any) => {
                errorHandler(exception, setError);
                setLoaderVisibility(false);
            });
    }
    const updateRole = (data: RoleFormValues) => {
        if (role) {
            axiosConfig
                .put(`${getPrivilegeRoute('role')}/${role.id}`, data)
                .then((response: { data: { data: Role; }; }) => {
                    if (response?.data?.data) {
                        callBack && callBack(response?.data?.data);
                    }
                    setLoaderVisibility(false);
                })
                .catch((exception: any) => {
                    errorHandler(exception, setError);
                    setLoaderVisibility(false);
                });
        }
    }

    useEffect(() => {
        setValue('name', watch('display_name').replace(/ /g, '_').toLowerCase());
    }, [watch('display_name'), setValue])

    return (
        <Fragment>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Loader visibility={loaderVisibility}/>
                <FormGroup>
                    <Label className='col-form-label m-0 required'>Key </Label>
                    <input className='form-control' name={'name'}
                           type={'text'}
                           placeholder={'admin'} readOnly={true} {...register('name', {required: true})}/>
                    {errors && <span
                        className='d-block invalid-feedback'>{errors.name && (errors?.name?.message ? errors?.name?.message : `Please provide a valid name.`)}</span>}
                </FormGroup>
                <TextInput name={'display_name'} type={'text'}
                           label={'Name'} register={register}
                           errors={errors} placeholder={'Admin'} options={{required: true}}/>
                <TextInput name={'description'} type={'text'} label={'Description'} register={register}
                           errors={errors} placeholder={'This is Admin'}/>
                <FormGroup>
                    <Btn attrBtn={{
                        className: 'd-block w-100 mt-4',
                        color: 'primary',
                        type: 'submit'
                    }}>{role ? 'Update' : 'Create'}</Btn>
                </FormGroup>
            </Form>
        </Fragment>
    );
};

export default RoleForm;
